import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { App } from './App.js';
import { applyTelegramTheme, getTelegram } from './telegram.js';
import { RealtimeBridge } from './realtime.js';
import { ActivityStatistics } from './activity-statistics.js';
import './styles.css';
import { ApiClientError } from './api.js';

const telegram = getTelegram();
if (telegram) {
  applyTelegramTheme(telegram);
  telegram.onEvent('themeChanged', () => {
    applyTelegramTheme(telegram);
  });
  telegram.ready();
  telegram.expand();
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error) =>
        !(error instanceof ApiClientError && error.status === 429) && count < 1,
      staleTime: 15_000,
    },
  },
});
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <>
        <RealtimeBridge />
        <ActivityStatistics />
        <App />
      </>
    ),
  },
]);
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
